export default {"src":"/_next/static/media/large-map.7eccfece.svg","height":848,"width":1600,"blurWidth":0,"blurHeight":0};